import { Form, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';

import { fetchRules, updateRule } from 'services';
import { getRules } from 'store';
import { useFetchSelector, useLegalEntities } from 'hooks';
import { AntSelect } from 'components/common';
import { Rule } from 'types';
import { getSorter } from 'helpers';

import { useTableActionsColumn, useRulesTableColumns, useTableForm } from './hooks';
import { useUpdateSettings } from './hooks/use-update-settings';
import style from './AntSelectFilter.module.scss';

export const RulesPage = () => {
  const rules = useFetchSelector<Rule[]>(getRules, fetchRules);
  const { update, loading } = useUpdateSettings(updateRule);
  const { t } = useTranslation();
  const legalEntities = useLegalEntities();
  const [entity, setEntity] = useState('ITR-BEL');

  const { form, isEditing, save, edit, cancel } = useTableForm<Rule>(rules, (rule) => rule.compensationType, update);
  const formActionsColumn = useTableActionsColumn(loading, isEditing, save, edit, cancel);
  const columns = useRulesTableColumns(form, loading, isEditing, formActionsColumn);

  const filteredRules: Rule[] = useMemo(() => {
    return rules
      .filter((item: Rule) => item.legalEntity === entity)
      .sort(getSorter(({ compensationType }) => compensationType === 'Other'));
  }, [entity, rules]);

  return (
    <Form form={form} component={false}>
      <AntSelect
        allowClear={false}
        formItemProps={{ label: t('byEntity'), className: `${style.antSelectFilter}` }}
        value={entity}
        options={legalEntities}
        className={style.antSelect}
        onChange={(filter: string) => setEntity(filter)}
      />
      <Table dataSource={filteredRules} columns={columns} rowKey="compensationType" pagination={false} />
    </Form>
  );
};
